import { useState } from "react";

function App() {
  const [email, setEmail] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch("https://06b2sn8tp6.execute-api.us-east-2.amazonaws.com/prod/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        // API Gateway returns error responses with JSON bodies
        const errorData = await response.json();
        throw new Error(errorData.message || "Subscription failed.");
      }

      const data = await response.json();
      alert(data.message); // Show success message
      setEmail(""); // Clear input after successful subscription
    } catch (error) {
      alert(error.message); // Show error message
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>
        Be the first to taste the forbidden—exclusive dark desires and haunting seductions delivered straight to your inbox. Sign up now… if you dare.
      </h1>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Subscribe</button>
      </form>
    </div>
  );
}

export default App;

